import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from '../../config/reduxIndex';
import PMTGS from '../../components/projectmanager/new/TaskGroup/PMTGS';

class PMTGSContainer extends Component {
	state = {
		currentItem: null,
		editing: null,
		saved: true,
		view: 'planning'
	}

	componentWillMount() {
		this.retrieveAndFilter();
	}

	componentDidUpdate(prevProps) {
		if (prevProps !== this.props) {
			this.retrieveAndFilter();
		}
	}

	retrieveAndFilter = () => {
		const p = this.props;
		this.setState({
			currentItem: p.reduxData.storedPhases[this.props.reduxData.currentPhase]
		})
	}

	setView = (e) => {
		this.setState({
			view: e,
		})
	}

	goToDesktop = () => {
		const { setRoute } = this.props;
		setRoute('/projectmanager/desktop');
	}

	render() {
		return (
			<PMTGS {...this.props} state={this.state} setView={this.setView} goToDesktop={this.goToDesktop} goBack={this.goBack} />
		);
	}

	goBack = () => {
		const { setRoute, changeMode } = this.props;
		changeMode("phase", null);
		//setRoute('/projectmanager/');
	}
}
function mapStateToProps(state) {
	return {
		reduxData: state.pmData
	}
}

const mapDispatchToProps = dispatch => {
	return {
		setRoute: (route) => {
			dispatch(actions.routing.setRoute(route));
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(PMTGSContainer);


// WEBPACK FOOTER //
// ./src/containers/projectmanager/PMTGSContainer.js